import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import Teachers from './pages/Teachers';
import Enrollments from './pages/Enrollments';
import Attendances from './pages/Attendances';
import Payments from './pages/Payments';
import Groups from './pages/Groups';
import Disciplines from './pages/Disciplines';
import Levels from './pages/Levels';
import Schedules from './pages/Schedules';
import Reports from './pages/Reports';
import ReportPayments from './pages/ReportPayments';
import ReportFinancial from './pages/ReportFinancial';
import ReportStudents from './pages/ReportStudents';
import ReportAttendances from './pages/ReportAttendances';
import SupportDashboard from './pages/SupportDashboard';
import Tenants from './pages/Tenants';
import Users from './pages/Users';
import Locations from './pages/Locations';
import Availability from './pages/Availability';
import Profile from './pages/Profile';
import SetupPassword from './pages/SetupPassword';
import OnboardingWizard from './pages/OnboardingWizard';
import ProviderAds from './pages/ProviderAds';
import PerformanceSettings from './pages/PerformanceSettings';
import PerformanceConfigRoute from './components/PerformanceConfigRoute';
import PerformanceResults from './pages/PerformanceResults';
import PerformanceDashboard from './pages/PerformanceDashboard';
import Layout from './components/Layout';
import { useAuth } from './contexts/AuthContext';
import { planFeatures } from './utils/planFeatures';
import './App.css';

function PremiumFeature({ children }) {
  const { user } = useAuth();
  if (planFeatures(user).performance !== false) return children;
  return (
    <div className="card" style={{ margin: 24, padding: 24 }}>
      <h2>Incluido en Premium</h2>
      <p>El módulo de pruebas está disponible en el plan Premium.</p>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/setup-password" element={<SetupPassword />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/students"
            element={
              <PrivateRoute>
                <Layout>
                  <Students />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/teachers"
            element={
              <PrivateRoute>
                <Layout>
                  <Teachers />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/enrollments"
            element={
              <PrivateRoute>
                <Layout>
                  <Enrollments />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/attendances"
            element={
              <PrivateRoute>
                <Layout>
                  <Attendances />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <PrivateRoute>
                <Layout>
                  <Payments />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/groups"
            element={
              <PrivateRoute>
                <Layout>
                  <Groups />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/disciplines"
            element={
              <PrivateRoute>
                <Layout>
                  <Disciplines />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/levels"
            element={
              <PrivateRoute>
                <Layout>
                  <Levels />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/schedules"
            element={
              <PrivateRoute>
                <Layout>
                  <Schedules />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/locations"
            element={
              <PrivateRoute>
                <Layout>
                  <Locations />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/availability"
            element={
              <PrivateRoute>
                <Layout>
                  <Availability />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Layout>
                  <Reports />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/reports/payments"
            element={
              <PrivateRoute>
                <Layout>
                  <ReportPayments />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/reports/financial"
            element={
              <PrivateRoute>
                <Layout>
                  <ReportFinancial />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/reports/students"
            element={
              <PrivateRoute>
                <Layout>
                  <ReportStudents />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/reports/attendances"
            element={
              <PrivateRoute>
                <Layout>
                  <ReportAttendances />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/support"
            element={
              <PrivateRoute>
                <Layout>
                  <SupportDashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/tenants"
            element={
              <PrivateRoute>
                <Layout>
                  <Tenants />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <Layout>
                  <Users />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/onboarding"
            element={
              <PrivateRoute>
                <Layout>
                  <OnboardingWizard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/provider-ads"
            element={
              <PrivateRoute>
                <Layout>
                  <ProviderAds />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/performance"
            element={
              <PrivateRoute>
                <Layout>
                  <PremiumFeature>
                    <PerformanceConfigRoute>
                      <PerformanceSettings />
                    </PerformanceConfigRoute>
                  </PremiumFeature>
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/performance/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <PremiumFeature>
                    <PerformanceDashboard />
                  </PremiumFeature>
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/performance/results"
            element={
              <PrivateRoute>
                <Layout>
                  <PremiumFeature>
                    <PerformanceResults />
                  </PremiumFeature>
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Layout>
                  <Profile />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

